import { useEffect, useState } from 'react'
import api from '@/services/api'

export type CsTeamOption = { id: string; name: string }

export function useCsTeamOptions(enabled: boolean) {
  const [options, setOptions] = useState<CsTeamOption[]>([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!enabled) {
      setOptions([])
      return
    }

    let cancelled = false
    setLoading(true)

    api
      .get('/users', {
        params: { role: 'cs', limit: 100, sortBy: 'name', sortOrder: 'asc' },
      })
      .then((resp) => {
        if (cancelled) return
        const raw = resp.data.data ?? resp.data ?? []
        const items = (Array.isArray(raw) ? raw : [])
          .map((user: { id: string; name: string }) => ({
            id: user.id,
            name: user.name,
          }))
          .sort((a, b) => a.name.localeCompare(b.name, 'pt-BR'))
        setOptions(items)
      })
      .catch(() => {
        if (!cancelled) setOptions([])
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })

    return () => {
      cancelled = true
    }
  }, [enabled])

  return { options, loading }
}
